import axios from 'axios';

export {
  downloadOrders,
  placeOrderV2,
  updateOrderStatus,
  updateOrder,
  updateOrderNumbers,
  getPaginatedOrders,
  getOrderStatistics,
};

function downloadOrders(payload, orderIds) {
  return axios.get("/api/downloadOrders", { params: { ...payload, orderIds } });
}

async function getOrderStatistics(payload = {}) {
  try {
    const { data } = await axios.get("/api/getOrderStatistics", { params: payload });
    // const { statistics } = data.payload.data;
    return data;
  } catch (ex) {
    console.dir(ex);
    return {};
  }
}

async function getPaginatedOrders(payload = { query_type: "ALL", page: 1, limit: 100 }) {
  try {
    const { data } = await axios.get("/api/getPaginatedOrders", { params: payload });
    const { metadata, orders } = data;
    return { metadata, orders };
  } catch (ex) {
    console.dir(ex);
    return { metadata: { total: 0, page: 0, limit: 0 }, orders: [] };
  }
}

function placeOrderV2(payload) {
  return axios.post("/api/placeOrderV2", payload);
}

function updateOrderStatus(orderId, { status, orderCancelled, feedback }) {
  return axios.put(`api/orders/updateStatus/${orderId}`, { params: { status, orderCancelled, feedback } });
}

function updateOrderNumbers(orderId, { offers, negotiation }) {
  return axios.put(`api/orders/updateOrderNumbers/${orderId}`, { params: { offers, negotiation } });
}

function updateOrder(orderId, order, feedback) {
  return axios.put(`api/orders/${orderId}`, { params: { order, feedback } });
}